import { lazy } from "react";
import { ALLOWED_MODULES } from "../../constants/enums";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { APP_EVENTS_ROUTE } from "./Event.paths";

const Leads = Loadable(
	lazy(() =>
		import("./EventsList").then(({ EventsList }) => ({
			default: EventsList,
		}))
	)
);



export const eventRoutes = [
	{
		path: APP_EVENTS_ROUTE,
		exact: true,
		element: (
			<AuthorizedRoute
				allowFullAccess
				moduleIds={[ALLOWED_MODULES.LEADS]}
			>
				<Leads />
			</AuthorizedRoute>
		),
	},
	
];
